import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {toFSDateTime} from "../../util/timeutils";
import {Row} from 'antd';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

// Deterministic Color List
const color_palette = [
    'rgb(255, 99, 132)',
    'rgb(54, 162, 235)',
    'rgb(255, 206, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(255, 159, 64)',
    'rgb(75, 192, 192)',
];


export const LightChart = ({rows, events, title}) => {
    if (events === undefined) {
        return <div />
    }

    // create a row name map
    const nameMap = {}
    rows.forEach(r => {
        const {id: rowId, rowName} = r;
        if (nameMap[rowId] === undefined) {
            nameMap[rowId] = rowName;
        }
    });

    // const graphEvents = events.filter(row => row.metric === RowMetricType.Light);
    const graphEvents = events;
    const lightMap = {}
    // make a pass to partition the data by rows
    graphEvents.forEach(e => {
        const {rowId, value, timestamp} = e;
        if (lightMap[rowId] === undefined) {
            lightMap[rowId] = []
        }
        lightMap[rowId].push({
            x: toFSDateTime(new Date(timestamp)),
            y: value
        });
    });

    const dataSets = [];
    let index = 0;
    for (const [rowId, data] of Object.entries(lightMap)) {
        const color = color_palette[index];
        dataSets.push({
            label: nameMap[rowId],
            data,
            fill: false,
            borderColor: color,
            tension: 0.1
        });

        index = (index + 1) % color_palette.length;
    }

    const data = {
        datasets: dataSets
    }

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: title,
            },
        },
    };

    return <div>
        <Row>
            <Line options={options} data={data} />
        </Row>
    </div>
}